import { render, staticRenderFns } from "./TradesmanInformation.vue?vue&type=template&id=7255100e&scoped=true&"
import script from "./TradesmanInformation.vue?vue&type=script&lang=js&"
export * from "./TradesmanInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7255100e",
  null
  
)

export default component.exports